import { ASK_USER_QUESTION_TOOL_NAME, ASK_USER_QUESTIONS_TOOL_NAME } from './askUserQuestionSpec';
export const DEFAULT_STANDALONE_TOOLS = new Set([ASK_USER_QUESTION_TOOL_NAME, ASK_USER_QUESTIONS_TOOL_NAME]);
function isToolMessage(message) {
  return message.role === 'ASSISTANT' && message.blocks.some(block => block.type === 'TOOL');
}
function hasStandalonePair(message, standaloneNames) {
  for (const block of message.blocks) {
    if (block.type === 'TOOL') {
      for (const pair of block.pairs) {
        if (standaloneNames.has(pair.input.name)) return true;
      }
    }
  }
  return false;
}
function collectPairs(messages) {
  const pairs = [];
  let failedPairs = 0;
  for (const message of messages) {
    for (const block of message.blocks) {
      if (block.type === 'TOOL') {
        const toolBlock = block;
        for (const pair of toolBlock.pairs) {
          var _pair$output;
          pairs.push(pair);
          if (((_pair$output = pair.output) === null || _pair$output === void 0 ? void 0 : _pair$output.type) === 'TEXT' && pair.output.isError) {
            failedPairs++;
          }
        }
      }
    }
  }
  return {
    pairs,
    failedPairs
  };
}
export function groupMessages(messages, standaloneToolNames = DEFAULT_STANDALONE_TOOLS) {
  const groups = [];
  let i = 0;
  while (i < messages.length) {
    if (isToolMessage(messages[i])) {
      let run = [];
      while (i < messages.length && isToolMessage(messages[i])) {
        const msg = messages[i];
        if (hasStandalonePair(msg, standaloneToolNames)) {
          if (run.length > 0) {
            const {
              pairs,
              failedPairs
            } = collectPairs(run);
            groups.push({
              type: 'tool-group',
              messages: run,
              pairs,
              failedPairs
            });
            run = [];
          }
          const {
            pairs,
            failedPairs
          } = collectPairs([msg]);
          groups.push({
            type: 'tool-group',
            messages: [msg],
            pairs,
            failedPairs
          });
        } else {
          run.push(msg);
        }
        i++;
      }
      if (run.length > 0) {
        const {
          pairs,
          failedPairs
        } = collectPairs(run);
        groups.push({
          type: 'tool-group',
          messages: run,
          pairs,
          failedPairs
        });
      }
    } else {
      groups.push({
        type: 'message',
        message: messages[i]
      });
      i++;
    }
  }
  return groups;
}